(ns com.theplantscape.plant-web.components.images)

(def default-images
  ["https://img.theplantscape.com/api/image/do/missing.jpg"
   "https://img.theplantscape.com/api/image/do/missing.jpg"])

(defn default-image [] (rand-nth default-images))
(defn profile-image
  ([image] (profile-image image "medium"))
  ([image profile]
   (str (or image (default-image)) "?p=" profile)))

(defn build-base-image-path
  ([domain name type]
   (if name 
     (str domain "/" type "/" (or name "default") ".jpg")
     (default-image))))


(defn build-raw-image-path
  ([name] (build-raw-image-path "http://127.0.0.1:3000/api/" name))
  ([domain name]
   (if (sequential? name)
     (mapv #(build-base-image-path domain %  "raw") name)
     (build-base-image-path domain name "raw"))))


(defn build-image-path
  ([name] (build-image-path "http://127.0.0.1:3000/api/" name))
  ([domain name]
   (if (sequential? name)
     (mapv #(build-base-image-path domain % "image") name)
     (build-base-image-path domain name "image"))))

(defn build-api-image-path
  ([name] (build-api-image-path "http://127.0.0.1:3000/api/" name))
  ([domain name]
   (if (sequential? name)
     (mapv #(build-base-image-path domain % "") name)
     (build-base-image-path domain name "image"))))



